<template>
  <div class="login-container">
    <div class="container">
      <div class="row justify-content-center align-items-center min-vh-100">
        <div class="col-md-5 col-lg-4">
          <div class="card shadow">
            <div class="card-body p-5">
              <div class="d-flex justify-content-end mb-3">
                <LanguageSwitcher />
              </div>
              <h2 class="text-center mb-4">{{ $t('common.appName') }}</h2>
              <h5 class="text-center mb-4 text-muted">{{ $t('login.title') }}</h5>

              <div v-if="errorMessage" class="alert alert-danger" role="alert">
                {{ errorMessage }}
              </div>

              <!-- <div class="alert alert-info small mb-3" role="alert">
                <strong>Demo Accounts:</strong><br />
                Admin: admin@terreverdi.com / admin123<br />
                Employee: employee@terreverdi.com / emp123
              </div> -->

              <form @submit.prevent="handleLogin">
                <div class="mb-3">
                  <label for="email" class="form-label">{{ $t('login.email') }}</label>
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    v-model="email"
                    :placeholder="$t('login.emailPlaceholder')"
                    required
                  />
                </div>

                <div class="mb-3">
                  <label for="password" class="form-label">{{ $t('login.password') }}</label>
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    v-model="password"
                    :placeholder="$t('login.passwordPlaceholder')"
                    required
                  />
                </div>

                <div class="d-grid">
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg"
                    :disabled="isLoading"
                  >
                    <span v-if="isLoading">
                      <span
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {{ $t('login.loggingIn') }}
                    </span>
                    <span v-else>{{ $t('login.loginButton') }}</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:4000";

export default {
  name: "Login",
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      isLoading: false,
    };
  },
  mounted() {
    // Clear any existing session
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  },
  methods: {
    async handleLogin() {
      this.errorMessage = "";
      this.isLoading = true;

      try {
        const response = await axios.post(`${API_URL}/api/login`, {
          email: this.email,
          password: this.password,
        });

        if (response.data.success) {
          const { user, token } = response.data.data;

          // Store user info with token in localStorage
          const userWithToken = { ...user, token };
          localStorage.setItem("user", JSON.stringify(userWithToken));
          localStorage.setItem("token", token);

          // Redirect based on role
          if (user.role === "admin") {
            this.$router.push("/dashboard");
          } else {
            this.$router.push("/employee/dashboard");
          }
        } else {
          this.errorMessage = response.data.message || "Login failed";
        }
      } catch (error) {
        console.error("Login error:", error);

        if (error.response) {
          // Server responded with error
          this.errorMessage =
            error.response.data.message || "Invalid credentials";
        } else if (error.request) {
          // Request made but no response
          this.errorMessage = "Cannot connect to server. Please try again.";
        } else {
          // Other errors
          this.errorMessage = "An error occurred. Please try again.";
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

.card {
  border: none;
  border-radius: 15px;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-weight: 600;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #5568d3 0%, #6439a1 100%);
  transform: translateY(-2px);
  transition: all 0.3s ease;
}

.form-control {
  border-radius: 8px;
  padding: 12px;
}

.form-control:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}
</style>
